import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EXPENSE_SURVEY_CONSTANTS } from '../../constants/app-constants';

@Component({
  selector: 'rcn-bc-upload-confirm-dialog',
  templateUrl: 'bc-upload-confirm-dialog.component.html',
  styleUrls: ['bc-upload-confirm-dialog.component.scss'],
})
export class BusinessComponentConfirmDialog implements OnInit {

  @Output() proceedImport = new EventEmitter();
  @Output() closeConfirmDialog = new EventEmitter();

  constructor() { }

  ngOnInit() {

  }

  closeDialog() {
    this.closeConfirmDialog.emit();
  }

  importBusinessComponent(): void {
    this.proceedImport.emit();
  }
}
